import './style.scss';

const l23bShowPopup = () => {
    const popup = document.getElementsByClassName('l23b-pop-up');

    if(!popup || popup.length === 0) return;

    [...popup].forEach(elem => {

        const timing = elem.dataset.timing;

        const timingNum = parseInt(timing, 10);

        const timingMs = timingNum * 1000;

        setTimeout(() => {
            elem.classList.add('l23b-pop-up--is-show')
        }, timingMs);
    })
}

const l23bHidePopup = () => {
    const btn = document.querySelectorAll('.l23b-pop-up__close-btn, .l23b-pop-up__wrapper-background');

    if (!btn || btn.length === 0) return;

    [...btn].forEach(elem => {

        elem.addEventListener('click', () => {
            const popup = document.querySelector('.l23b-pop-up');

            if (popup) {
                popup.classList.remove('l23b-pop-up--is-show');
            }
        })
        
    })
}
l23bHidePopup();

const l23bShowPopupScrollBlockPosition = () => {
    const trigger = document.getElementsByClassName('wp-block-lab23-blocks-pop-up');

    if (!trigger && trigger.length === 0) return;

    [...trigger].forEach(elem => {
        const observer = new IntersectionObserver((entries) => {
            for (const e of entries) {
                if (e.isIntersecting) {
                    // ウィンドウ内に入った時の処理
                    const popup = elem.querySelector('.l23b-pop-up');

                    if (!popup.classList.contains('l23b-pop-up--is-showed')) {
                        popup.classList.add('l23b-pop-up--is-show');
                        popup.classList.add('l23b-pop-up--is-showed');
                    }
                }
            }
        }, {});
        observer.observe(elem);
    })

    
}

const l23bSetPopup = () => {
    const popup = document.getElementsByClassName('l23b-pop-up');

    if(!popup || popup.length === 0) return;

    [...popup].forEach(elem => {
        const triggerType = elem.dataset.triggerType;

        if (!triggerType) return;

        switch (triggerType) {
            case 'timeout':
                l23bShowPopup();
                break;

            case 'position':
                l23bShowPopupScrollBlockPosition();
                break;
        }
    });

    
}
l23bSetPopup();